import { useLocation, Navigate } from 'react-router-dom'
import { useGetProfileQuery } from '../api'
import { AuthBootstrapSpinner } from '../routes/AuthBootstrapSpinner'
import { routesGuest } from '../consts'

interface IRequireAuthProps {
  children: any
}

export const RequireAuth: React.FC<IRequireAuthProps> = ({ children }) => {
  const location = useLocation()
  const { data: user, isLoading, isFetching, isUninitialized, isError } = useGetProfileQuery()

  const pending = isUninitialized || isLoading || (isFetching && !user)
  if (pending) {
    return <AuthBootstrapSpinner />
  }

  if (isError || !user) {
    return <Navigate to={routesGuest.ROOT.path} state={{ from: location }} replace />
  }

  return children
}
